import { registerLocaleData } from '@angular/common';
import {
	HTTP_INTERCEPTORS,
	provideHttpClient,
	withInterceptorsFromDi,
} from '@angular/common/http';
import localePt from '@angular/common/locales/pt';
import {
	ErrorHandler,
	NgModule,
	APP_INITIALIZER,
	LOCALE_ID,
} from '@angular/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Router } from '@angular/router';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { createErrorHandler, TraceService } from '@sentry/angular';
import { NgChartsModule } from 'ng2-charts';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { environment } from '../environments/environment';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { AuthGuardService } from './core/guards/auth-guard.service';
import { ErrorInterceptor } from './core/interceptors/error.interceptor';
import { WebInterceptor } from './core/interceptors/web.interceptor';
import { AuthenticationsModule } from './modules/authentications/authentications.module';
import { BeneficiariesModule } from './modules/beneficiaries/beneficiaries.module';
import { BulkActionsModule } from './modules/bulk-actions/bulk-actions.module';
import { NotificationsModule } from './modules/notifications/notifications.module';
import { OrganizationsModule } from './modules/organizations/organizations.module';
import { PartnersModule } from './modules/partners/partners.module';
import { UsersModule } from './modules/users/users.module';
import { WalletsModule } from './modules/wallets/wallets.module';
import { SharedModule } from './shared/shared.module';
import { AppReducer } from './store/app.reducer';
import { AppErrorHandler } from './utils/logger/app-error-handler';

registerLocaleData(localePt);

@NgModule({
	bootstrap: [AppComponent],
	declarations: [AppComponent],
	imports: [
		AppRoutingModule,
		AuthenticationsModule,
		BeneficiariesModule,
		BrowserAnimationsModule,
		BrowserModule,
		CoreModule,
		EffectsModule.forRoot([]),
		MatMomentDateModule,
		NgChartsModule,
		NgxMaskDirective,
		NgxMaskPipe,
		NgxSkeletonLoaderModule.forRoot({
			animation: 'pulse',
			loadingText: 'carregando...',
		}),
		NotificationsModule,
		OrganizationsModule,
		StoreDevtoolsModule.instrument({
			logOnly: environment.isProduction,
			maxAge: 25,
		}),
		StoreModule.forRoot(AppReducer),
		PartnersModule,
		SharedModule,
		UsersModule,
		WalletsModule,
		BulkActionsModule,
	],
	providers: [
		AuthGuardService,
		{ provide: HTTP_INTERCEPTORS, useClass: WebInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
		{ provide: ErrorHandler, useClass: AppErrorHandler },
		{
			provide: ErrorHandler,
			useValue: createErrorHandler(),
		},
		{ provide: LOCALE_ID, useValue: 'pt-BR' },
		{
			deps: [Router],
			provide: TraceService,
		},
		{
			deps: [TraceService],
			useFactory: () => (): void => {},
			provide: APP_INITIALIZER,
			multi: true,
		},
		provideNgxMask(),
		provideHttpClient(withInterceptorsFromDi()),
	],
})
export class AppModule {}
